import { render, staticRenderFns } from "./BannerCate.vue?vue&type=template&id=1ebf64c9&"
import script from "./BannerCate.vue?vue&type=script&lang=js&"
export * from "./BannerCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports